import { StackItem } from '../../../../interfaces/use-order-item-stack.types';
import { GridStoreApi } from './gridStore';

interface ProduceItemsToStoreParams {
  api: GridStoreApi;
  combinationKey: string;
  items: StackItem[];
}

export const produceItemsToStore = ({ api, combinationKey, items }: ProduceItemsToStoreParams) => {
  items.forEach((item) => {
    if (!item.skuId) {
      return;
    }
    api
      .getState()
      .setCellQuantity({ combinationKey, skuId: item.skuId, quantity: item.quantity ?? 0 });
    api.getState().stackItem(item);
  });
};
